import axios from 'axios'
import head from 'lodash/head'
import { load_one, load_many, _get_counts } from '../action-helpers.js'
import http from '@/http'

export default {

    /**
     * Lädt eine Seite Kampagnen vom Server (server-seitige Paginierung).
     */
    async loadPage({ commit }, { page = 0, size = 20 } = {}) {
        const response = await http({ method: 'GET', url: 'campaigns', params: { page, size } })
        const campaigns = response.data.content
        commit('SET_MANY', { content: campaigns })
        commit('SET_COUNTS', { content: _get_counts(response.headers) })
        return campaigns
    },

    create({ dispatch }, { model }) {
        return axios.post('/api/v1/campaigns', model).then(response => {
            return Promise.all([
                dispatch('loadOne', { id: response.data.id }),
                dispatch('loadAll', { force: true })
            ]).then(head)
        })
    },

    loadAll: load_many('campaigns'),
    loadAllByCompanyId: load_many('campaigns', { params: { company: ':companyId' }}),
    loadOne: load_one('campaigns/:id'),

    update({ dispatch }, { model }) {
        return axios.put(`/api/v1/campaigns/${model.id}`, model).then(() => {
            return Promise.all([
                dispatch('loadOne', { id: model.id, force: true }),
                dispatch('loadAll', { force: true })
            ]).then(head)
        })
    },

}
